// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zAhyv","debitos":"styles_debitos__wMKsm","skeleton_container":"styles_skeleton_container__CV6cx","skeleton":"styles_skeleton__+Noul"};